import bsnlLogin from './bsnlLogin'
import business from './business'
import dxpDashboard from './dxpDashboard'
import fmApplicant from './fmApplicant'
import dxpGlobal from './dxpGlobal'
import dxpLogin from './dxpLogin'
import menuLog from './menuLog'
import numberSelect from './numberSelect'
import remoteHeaderPlugin from './remoteHeaderPlugin'
import search from './search'
import selectOffer from './selectOffer'
import selectPlan from './selectPlan'
import dxpSetting from './dxpSetting'
import subsSelection from './subsSelection'
import dxpUser from './dxpUser'
import addServices from './addServices'
import assignMembersArea from './assignMembersArea'
import billDesk from './billDesk'
import billpayment from './billpayment'
import browserAnalysisMgr from './browserAnalysisMgr'
import casualExtension from './casualExtension'
import changeOfIndicatorISDN from './changeOfIndicatorISDN'
import changeOfIndicatorNormal from './changeOfIndicatorNormal'
import commissionQuery from './commissionQuery'
import componentMgr from './componentMgr'
import customerAccount from './customerAccount'
import customerAccountProfile from './customerAccountProfile'
import disconnection from './disconnection'
import ftthConversions from './ftthConversions'
import home from './home'
import leadsManagement from './leadsManagement'
import logMgr from './logMgr'
import manageExtension from './manageExtension'
import menu from './menu'
import modifyBroadbandNetworkIP from './modifyBroadbandNetworkIP'
import modifyFeature from './modifyFeature'
import modifyForService from './modifyForService'
import modifyGoods from './modifyGoods'
import modifyPlan from './modifyPlan'
import modifyingFixedLineNumberGroup from './modifyingFixedLineNumberGroup'
import tenancy from './tenancy'
import tenancyUser from './tenancyUser'
import billingAccountInfo from './billingAccountInfo'
import customerInfo from './customerInfo'
import leaseLine from './leaseLine'
import newConnection from './newConnection'
import selectService from './selectService'
import clientMgr from './clientMgr'
import billingInformation from './billingInformation'
import onlinePayment from './onlinePayment'
import queryBillingInformation from './queryBillingInformation'
import queryReceiptInformation from './queryReceiptInformation'
import PortalMgr from './PortalMgr'
import portletMgr from './portletMgr'
import profileMgr from './profileMgr'
import reconnection from './reconnection'
import roleMgr from './roleMgr'
import salesOrderMgr from './salesOrderMgr'
import shift from './shift'
import sysParam from './sysParam'
import ttOrder from './ttOrder'
import transfer from './transfer'
import transferCustomer from './transferCustomer'
import userMgr from './userMgr'
import virtualChangeOfDestinationNumber from './virtualChangeOfDestinationNumber'
import virtualConvertToFixedLine from './virtualConvertToFixedLine'

export default [
  bsnlLogin,
  business,
  dxpDashboard,
  fmApplicant,
  dxpGlobal,
  dxpLogin,
  menuLog,
  numberSelect,
  remoteHeaderPlugin,
  search,
  selectOffer,
  selectPlan,
  dxpSetting,
  subsSelection,
  dxpUser,
  addServices,
  assignMembersArea,
  billDesk,
  billpayment,
  browserAnalysisMgr,
  casualExtension,
  changeOfIndicatorISDN,
  changeOfIndicatorNormal,
  commissionQuery,
  componentMgr,
  customerAccount,
  customerAccountProfile,
  disconnection,
  ftthConversions,
  home,
  leadsManagement,
  logMgr,
  manageExtension,
  menu,
  modifyBroadbandNetworkIP,
  modifyFeature,
  modifyForService,
  modifyGoods,
  modifyPlan,
  modifyingFixedLineNumberGroup,
  tenancy,
  tenancyUser,
  billingAccountInfo,
  customerInfo,
  leaseLine,
  newConnection,
  selectService,
  clientMgr,
  billingInformation,
  onlinePayment,
  queryBillingInformation,
  queryReceiptInformation,
  PortalMgr,
  portletMgr,
  profileMgr,
  reconnection,
  roleMgr,
  salesOrderMgr,
  shift,
  sysParam,
  ttOrder,
  transfer,
  transferCustomer,
  userMgr,
  virtualChangeOfDestinationNumber,
  virtualConvertToFixedLine,
]
